// src/telas/minha-conta/financeiro/index.tsx

import styles from "../styles.module.css";
import { useContext } from "react";
import { FormularioContext } from "..";

export function Financeiro() {
  const context = useContext(FormularioContext);

  function atualizarFormulario(event: React.ChangeEvent<HTMLInputElement>) {
    let nome  = event.target.name;
    let value = `${event.target.value}`.toUpperCase();

    context?.setFormulario({ ...context.formulario, ...{ [nome]: value } });
  }

  return (
    <>
      {/* BANCO */}
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>Banco</span>
          <input
            value={context?.formulario.A2_BANCO}
            type="text"
            name="A2_BANCO"
            onChange={atualizarFormulario}
            placeholder="Código do Banco"
          />
        </div>
      </div>

      {/* AGÊNCIA */}
      <div className={styles.groupInput}>
        <span>Agência</span>
        <input
          value={context?.formulario.A2_AGENCIA}
          type="text"
          name="A2_AGENCIA"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>

      {/* DÍGITO AGÊNCIA */}
      <div className={styles.groupInput}>
        <span>Dígito Verificador da Agência</span>
        <input
          maxLength={5}
          value={context?.formulario.A2_DVAGE}
          type="text"
          name="A2_DVAGE"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>

      {/* NÚMERO DA CONTA */}
      <div className={styles.groupInput}>
        <span>Número da Conta</span>
        <input
          maxLength={20}
          value={context?.formulario.A2_NUMCON}
          type="text"
          name="A2_NUMCON"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>

      {/* DÍGITO CONTA */}
      <div className={styles.groupInput}>
        <span>Dígito Verificador da Conta</span>
        <input
          maxLength={5}
          value={context?.formulario.A2_DVCTA}
          type="text"
          name="A2_DVCTA"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>

      {/* PIX */}
      <div className={styles.groupInput}>
        <span>PIX</span>
        <input
          maxLength={20}
          value={context?.formulario.A2_ZPIX}
          type="text"
          name="A2_ZPIX"
          onChange={atualizarFormulario}
          placeholder=""
          style={{ width: "100%" }}
        />
      </div>
    </>
  );
}